<template>
    <div>
        <section>
        <div class="videoFlex">
            <div class="video-section">
                <iframe id="stream-webinar" frameborder="0" style="width: 100%; height: 550px"></iframe>
                <div class="slide-close-btn" @click="hideSlide()">X</div>
            </div>
            <div class="slide-section">

                <div id="scroll-chat">
                    <div class="chat">

                    </div>
                </div>
                <div class="msg-input">
                    <form class="form-flex" v-if="!chatDisabled">
                        <textarea class="send-msg" placeholder="Message"></textarea>
                        <button type="button" class="sendMessage" @click="sendMessage()"><i class="fas fa-comment"></i></button>
                    </form>
                    <form class="form-flex" v-else>
                        <textarea placeholder="Chat has been disabled by admin" style="width:100%;" disabled></textarea>
                    </form>
                </div>
            </div>
        </div>
    </section>
        <section>
        <div class="video-details">
            <div class="container">
                <div class="row">
                    <div class="col-md-9">
                        <div class="video-action">
                            <div class="webinar-video-title">{{ webinarData.title }}</div>
                            <div class="webinar-speakers">
                                <p class="list-data"><b>Speakers:</b>
                                    <a href="javascript:;" v-for="sp in webinarData.webinarSpeakers" v-if="webinarData.webinarSpeakers" :data-key="sp.speaker_enc_id" @click="SpeakerModal($event)">
                                      {{sp.full_name}}
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="live-count">
                            <i class="fas fa-circle"></i> Viewers: <span id="viewers"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
      <SpeakerModal></SpeakerModal>
    </div>
</template>

<script>
    import firebase from "firebase";
    import axios from "axios";
    import toastr from "../../../public/js/toastr";
    import SpeakerModal from "@/components/SpeakerModal";
    import {paymentAccessToken} from "../../_helpers/apiRoute.js";
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components:{
          SpeakerModal
        },
        data: function(){
            return {
              specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
              db: firebase.database(),
              ref: '',
              webinarId:'',
              webinarData:"",
              userImage:"",
              chatDisabled:true,
              monthDict: {
                0: 'Jan',
                1: 'Feb',
                2: 'Mar',
                3: 'Apr',
                4: 'May',
                5: 'June',
                6: 'July',
                7: 'Aug',
                8: 'Sep',
                9: 'Oct',
                10: 'Nov',
                11: 'Dec',
              },
            }
        },
        mounted(){
          var t = this;
          if (this.$route.query.id) {
            t.webinarId = t.$route.query.id;
            t.validateSession();

            var ref = t.db.ref(t.specialKey + '/userStatus/' + t.webinarId + '/' + t.$store.getters.getUser['user_id'])
            ref.set({
              'status': 'online',
            });
            var userLastOnlineRef = firebase.database().ref(t.specialKey + '/userStatus/' + t.webinarId + '/' + t.$store.getters.getUser['user_id']);
            userLastOnlineRef.onDisconnect().remove();
            var usersCount = t.db.ref(t.specialKey + '/userStatus/' + t.webinarId);
              var tempData = 0;
              var result2 = [];
              var usersCount2 = t.db.ref(t.specialKey + '/userStatusAdd/');
              usersCount2.on('value', function (data2) {
                  var resultData2 = [];
                  for (var k in data2.val()) {
                      resultData2.push([k, data2.val()[k]]);
                  }
                  tempData = data2.val();
                  document.getElementById('viewers').innerText = result2.length + tempData;
              });
            usersCount.on('value', function (data) {
                result2 = [];
              for (var i in data.val()) {
                result2.push([i, data.val()[i]]);
              }
                document.getElementById('viewers').innerText = result2.length + tempData;
            });
            t.db.ref(t.specialKey + '/conversations/' + t.webinarId).on('value', gotData, errData);
            function gotData(data) {
              var result = [];
              for (var i in data.val()) {
                result.push([i, data.val()[i], Date.parse(data.val()[i].full_date_time)]);
              }
              result.sort(function (a, b) {
                return a[2] - b[2];
              });
              for (var z = 0; z < result.length; z++) {
                if (!document.getElementById(result[z][0])) {
                  if(result[z][1].sender != t.$store.getters.getUser['user_id']){
                    t.showMessage(result[z][0], result[z][1].name, result[z][1].image, result[z][1].message,false);
                  } else {
                    t.showMessage(result[z][0], result[z][1].name, result[z][1].image, result[z][1].message, true);
                  }
                }
              }
            }

            function errData(data) {
              console.log('err');
            }
            $('#scroll-chat').perfectScrollbar();

            if(t.$store.getters.getUser['image']){
              t.userImage = t.$store.getters.getUser['image'];
            } else {
              let str = t.$store.getters.getUser['initials_color'];
              str = str.substring(1);
              t.userImage = 'https://ui-avatars.com/api/?name='+t.$store.getters.getUser['first_name']+'+'+t.$store.getters.getUser['last_name']+'&background='+str+'&color=fff';
            }
          } else {
            this.$router.push({path: '/dashboard'})
          }
        },
        methods:{
          sendMessage() {
            var t = this;
            let message = document.querySelector('.send-msg').value;
            if(message.trim() != "") {
              document.querySelector('.send-msg').value = "";
              var currentDate = new Date();
              var dateMain = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
              var getMins = currentDate.getMinutes();
              if (getMins < 10) {
                getMins = "0" + getMins;
              }
              var timeMain = currentDate.getHours() + ":" + getMins;
              var ref = t.db.ref(t.specialKey + '/conversations/' + t.webinarId + '/' + t.uniqueId())
              ref.set({
                'name': t.$store.getters.getUser['first_name'] + ' ' + t.$store.getters.getUser['last_name'],
                'sender': t.$store.getters.getUser['user_id'],
                'is_public': true,
                'reply_to': "",
                'message': message.trim(),
                'image': t.userImage,
                'date': dateMain,
                'time': timeMain,
                'full_date_time': String(currentDate),
              });
              var data = {
                'session_enc_id': t.webinarId,
                'message': message.trim(),
                'reply_to': ''
              }
              var url = this.$store.getters.getDomain;

              axios.post(`${url}api/v2/webinars/save-conversation`, data, {headers: requestHeaders()}).then(function (response) {
                // if (response['data']['response']['status'] == 200) {
                //   toastr.success('Query Send', 'Success');
                // }
              });
              var myElement = document.getElementsByClassName('chat')[0].offsetHeight - 80;
              document.getElementById('scroll-chat').scrollTop = myElement;
            }
          },
          showMessage(id,name,image,message,owner){
            let chat = document.querySelector('.chat');
            let chatBox = document.createElement('div');
            if(owner){
              chatBox.setAttribute('class', 'chat-box right-aligned');
            } else{
              chatBox.setAttribute('class', 'chat-box');
            }
            chatBox.setAttribute('id', id);
            chatBox.innerHTML = `<div class="user-icon">
                                          <img src="`+ image +`">
                                          </div>
                                          <div class="username-msg">
                                              <div class="us-name">`+ name +`</div>
                                              <div class="us-msg">` + message + `</div>
                                          </div>`;
            chat.appendChild(chatBox);
            var myElement = document.getElementsByClassName('chat')[0].offsetHeight - 80;
            document.getElementById('scroll-chat').scrollTop = myElement;
          },
          SpeakerModal(event) {
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/speaker-detail`, {speaker_enc_id: data_key}, {headers: requestHeaders()}).then(function (response) {
              if (response['data']['response']['status'] == 200) {
                t.speaker_data = response['data']['response']['data'];
                t.$children[0].getSpeakerData()
                $('#speaker').modal('show');
              }
            });
          },
          validateSession(){
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/webinars/validate-session`, {session_enc_id:t.$route.query.id}, {headers: requestHeaders()}).then(function (response) {
              if (response['data']['response']['status'] == 200) {
                  document.getElementById("stream-webinar").src = "https://www.empoweryouth.com/live-stream/audience?id=" + t.$route.query.id;
                  t.webinarData = response['data']['response']['data'];
                  t.chatDisabled = response['data']['response']['data'].show_chat == "1" ? false : true;
                  setTimeout(function () {
                      if(!t.chatDisabled){
                          let messageText = document.querySelector('.send-msg')
                          messageText.addEventListener('keyup', function (event) {
                              if (event.keyCode === 13) {
                                  event.preventDefault();
                                  t.sendMessage();
                              }
                          });
                      }
                  },1200)
              } else if(response['data']['response']['status'] == 409) {
                  t.registerWebinar(response['data']['response']['data'].webinar_enc_id);
                    alert('Please register to view this webinar');
                    t.$router.push({path: '/dashboard/webinars'})
              } else{
                alert('No Webinar Found');
              }
            });
          },
          registerWebinar(data_key) {
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/join-webinar`, {webinar_id: data_key}, {headers: requestHeaders()}).then(function (response) {
              if (response['data']['response']['status'] == 201) {

              } else if (response['data']['response']['status'] == 200) {
                t.paymentPage(response['data']['response']['callback'].payment_token, response['data']['response']['callback'].payment_enc_id, response['data']['response']['callback'].registration_enc_id)
              }
            });
          },
          paymentPage(paymentId, paymentEncId, registrationEncId) {
            var t = this;
              var options = {
                  "key": paymentAccessToken(), // Enter the Key ID generated from the Dashboard
                  "name": "My E-Campus",
                  "description": "Webinar Registration Fees",
                  "image": "https://www.myecampus.in/images/e_campus_logo.png",
                  "modal": {
                      "ondismiss": function () {
                          t.updateApplication('','', paymentEncId, registrationEncId,'cancelled');
                      }
                  },
                  "order_id": paymentId,
                  "handler": function (response){
                      t.updateApplication(response.razorpay_payment_id,response.razorpay_signature, paymentEncId, registrationEncId,'captured');
                  },
              };
              var rzp1 = new Razorpay(options);
              rzp1.open();
              rzp1.on('payment.failed', function (response){
                  t.updateApplication('','', paymentEncId, registrationEncId,'failed');
              });
            // Layer.checkout({
            //       token: paymentId,
            //       accesskey: paymentAccessToken(),
            //     },
            //     function (response) {
            //       t.updateApplication(response, paymentEncId, registrationEncId);
            //       if (response.status == "captured") {
            //         // response.payment_token_id
            //         // response.payment_id
            //       } else if (response.status == "created") {
            //       } else if (response.status == "pending") {
            //       } else if (response.status == "failed") {
            //
            //       } else if (response.status == "cancelled") {
            //       }
            //     },
            //     function (err) {
            //       console.log(err)
            //       //integration errors
            //     }
            // );
          },
        updateApplication(paymentId,paymentSignature, paymentEncId, registrationEncId,status) {
            var t = this;
            showLoader();
            var url = this.$store.getters.getDomain;
            var res = {};
            res['payment_id'] = paymentId;
            res['payment_status'] = status;
            res['payment_enc_id'] = paymentEncId;
            res['signature'] = paymentSignature;
            res['registration_enc_id'] = registrationEncId;
            axios.post(`${url}api/v2/webinars/update-status`, res, {
              headers: requestHeaders()
            }).then(function (response) {
              if (response['data']['response']['status'] == 200) {
                toastr.success('Webinar Fees ' + res.payment_status, 'Success');
                location.reload();
                // t.$router.push({path: '/dashboard'});
              }
              hideLoader();
            })
                .catch(function (error) {
                  // t.getFeeComponents();
                })
          },
          hideSlide() {
            let slideSec = document.querySelector('.slide-section');
            let videoSec = document.querySelector('.video-section');
            let chatBoxes = document.querySelector('.chat');
            if (slideSec.classList.contains('slide-hide')) {
              slideSec.classList.remove('slide-hide');
              videoSec.style.width = '70vw';
              chatBoxes.style.display = "block"

            } else {
              slideSec.classList.add('slide-hide');
              videoSec.style.width = '100vw';
              chatBoxes.style.display = "none";

            }
          },
          uniqueId() {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < 15; i++) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return this.$store.getters.getUser['user_id'] + result;
          },
        },
        beforeRouteLeave (to, from , next) {
          var t = this;
          var ref = t.db.ref(t.specialKey + '/userStatus/' + t.webinarId + '/' + t.$store.getters.getUser['user_id'])
          ref.remove();
          next()
        },
    }
</script>

<style scoped>
.msg-input{
    border:1px solid #eee;
    width: 100%;
    height: 80px;
    background: #fff;
    position: fixed;
    z-index:9;
}

.form-flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;

}
.msg-input .form-flex textarea{
    padding: 15px 20px;
    border: none;
    width: 86%;
    height: 100%;

}
.msg-input button{
    font-size: 25px;
    background: transparent;
    border: none;
    height: 100%;
    padding: 5px 10px;
}
.msg-input button:hover{
    color:#00a0e3;
}
.video-action .webinar-video-title{
    text-align: left;
    font-size: 20px;
    color: #333;
    font-family: roboto;
}
.webinar-speakers p span{
    font-weight: bold;
    color:#333;
}
.webinar-speakers p a{
    color:#000;
}
.webinar-speakers p a:hover{
    color:#00a0e3;
}
.mentor-heading {
    font-size: 25px;
    font-family: lora;
    color: #000;
    text-transform: capitalize;
}
.msg-input{
    position: absolute;
    bottom: 0;
}

.video-section iframe{
    width: 100%;
    height:100%;
    object-fit: contain;
    border: none;
}

.fullwidth-page > #wrapper.clearfix > .main-content{
    padding-top: 0px !important;
}
.videoFlex{
    display: flex;
}
.video-section{
    width: 70vw;
    height: calc(100vh - 65px);
    background: #000;
    position: relative;
}
.slide-section{
    width:30vw;
    height: calc(100vh - 65px);
    background: #eee;
    position: relative;
    overflow: hidden;
}
.slide-hide{
    width: 0vw;
    transition: .2s ease;
}
.slide-close-btn{
    position: absolute;
    top: 20px;
    right:0px;
    width: 30px;
    height: 30px;
    color: #000;
    background:#00a0e3;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    color:#fff;
    z-index: 999;
    border-radius: 10px 0 0 10px;
    line-height: 0px;
}
.video-details{
    background: #f8f8f8;
    padding: 20px 0;
}
.live-count{
    text-align:center;
    flex:1;
}
.live-count span{
    font-weight: bold;
}
.live-count i{
    color: green;
}
</style>